import {get, post,deletes,put} from '../utils/request.js' ;//导入axios实例文件中方法

//获取代办事项
export const getBacklog =(params)=>{
    return post(`/indexpage/getBacklog`,params);
}

//获取首页/模块首页轮播图数据
export const getModuleIndex =(params)=>{
    return post(`/indexpage/getModuleIndex`,params);
}

//获取首页导航栏数据
export const getAllCatalog =(params)=>{
    return post(`/product/allCatalog`,params);
}

//获取模块首页导航栏数据
export const getModuleCatalog =(params)=>{
    return post(`/product/catalog`,params);
}

//获取顶部热门搜索数据
export const getHotKeywords =(params)=>{
    return post(`/product/getHotKeywords`,params);
}

//获取采购车数量
export const getShopcarNum = () => {
  return post(`/cart/cartProductCount`, {});
}



// WEBPACK FOOTER //
// ./src/api/home.js